var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "0 -0.5 408 467.80000000000007",
    width: 2185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x2: 261.746,
    y1: 112.094,
    y2: 112.094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63be6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5bbc6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab96a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0.152,
    x2: 179.896,
    y1: 223.393,
    y2: 223.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ec6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45afe3"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 179.896,
    x2: 407.976,
    y1: 229.464,
    y2: 229.464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#fab716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fac412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac80f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 1.744,
    x2: 272.296,
    y1: 345.521,
    y2: 345.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7515b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.7 142.3L15 1.3C11.9-.5 8-.4 5 1.4c-3.1 1.8-5 5-5 8.6 0 0 .1 13 .2 34.4l179.7 179.7z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 44.4C.5 121.6 1.4 309 1.8 402.3L180 224.1z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.9 223l-141.2-80.7-81.9 81.8 92.4 92.4L403 240.3c3.1-1.8 5-5.1 5-8.6 0-3.6-2-6.9-5.1-8.7z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 402.3c.2 33.3.3 54.6.3 54.6 0 3.6 1.9 6.9 5 8.6 3.1 1.8 6.9 1.8 10 0l255.3-148.9-92.4-92.4z",
    fill: "url(#d)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay5);
export default __webpack_public_path__ + "static/media/google-play-5.159efeb55e32228c30bff5e61a5f8ef6.svg";
export { ForwardRef as ReactComponent };